import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { FacadeService } from '../../services/facade.service';
import { PATCH_INATTIVITA_CLUSTER, PATCH_INATTIVITA_CLUSTER_SUCCESS } from './cluster.actions';
import { switchMap, catchError } from 'rxjs/operators';
import { throwError, mergeMap } from 'rxjs';

import { IResponseCluster } from '../../interfaces/cluster';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';


//139172 – Tool per la rilevazione stato del PuntoPoste
@Injectable()
export class ClusterEffects {
constructor(private actions$: Actions, private facadeService: FacadeService, private api: ApiService) {}

patchInattivitaCluster$ = createEffect(() => {
    return this.actions$.pipe(
        ofType(PATCH_INATTIVITA_CLUSTER),
        switchMap(({ id, patchData }) => this.api.patchInattivitaCluster(id, patchData)),
        mergeMap((operationCluster: IResponseCluster) => {
        return [PATCH_INATTIVITA_CLUSTER_SUCCESS({ operationCluster }),];
            }),
            catchError((error: HttpErrorResponse) => {
                return throwError({ error });
        })
        );
        });
}
